<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <!-- Loại phân vùng -->
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect :options="typeAreaSelect.options" :data="typeAreaSelect.data" ref="typeAreaSelect">
                  </BaseSelect>
                </CCol>

                <!-- Đài truyền thanh -->
                <CCol xs="12" sm="6" md="6" xl="6">
                  <div class="form-group">
                    <label style="display: inline-flex;">Nhóm màn hình
                      <span class="required">*</span>
                      <CInputCheckbox custom :checked="isSelectedAllStation" class="ml-2"
                        @update:checked="changeSelectedAllStation($event)" addInputClasses="override-custom">
                      </CInputCheckbox>
                      Chọn tất cả
                    </label>
                    <multiselect id="stationSelect" v-model="screenStationSelect.data.model"
                      placeholder="Chọn nhóm màn hình" label="text" track-by="value"
                      :options="screenStationSelect.options" selectLabel="Chọn" deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn" :close-on-select="false"
                      :class="!(screenStationSelect.data.validator && screenStationSelect.data.validator.isValid == true) ? 'input-error' : ''"
                      :multiple="true">
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>

                    <div class="valid-error"
                      v-show="!(screenStationSelect.data.validator ? screenStationSelect.data.validator.isValid : true)">
                      {{
                        screenStationSelect.data.validator
                        ? screenStationSelect.data.validator.errorMessage
                        : ""
                      }}
                    </div>
                  </div>
                </CCol>

                <!-- Thiết bị -->
                <CCol xs="12" sm="6" md="6" xl="6">
                  <div class="form-group">
                    <label for="deviceSelect">Thiết bị</label>
                    <multiselect id="stationSelect" v-model="screenDeviceSelect.data.model" placeholder="Chọn thiết bị"
                      label="text" track-by="value" :options="screenDeviceSelect.options" selectLabel="Chọn"
                      deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false"
                      :class="!(screenDeviceSelect.data.validator && screenDeviceSelect.data.validator.isValid == true) ? 'input-error' : ''"
                      :multiple="true">
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>

                    <div class="valid-error"
                      v-show="!(screenDeviceSelect.data.validator ? screenDeviceSelect.data.validator.isValid : true)">
                      {{
                        screenDeviceSelect.data.validator
                        ? screenDeviceSelect.data.validator.errorMessage
                        : ""
                      }}
                    </div>
                  </div>
                </CCol>

                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect :options="modeSelect.options" :data="modeSelect.data" ref="modeSelect">
                  </BaseSelect>
                </CCol>


                <CCol xs="12" sm="12" md="6" xl="6" v-if="typeAreaSelect.data.model == 0">
                  <BaseSelect :options="typeFileSelect.options" :data="typeFileSelect.data" ref="typeFileSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6"
                  v-if="typeAreaSelect.data.model == 0 && typeFileSelect.data.model == 0">
                  <BaseSelect :options="sourceTypeSelect.options" :data="sourceTypeSelect.data" ref="sourceTypeSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6" v-if="typeAreaSelect.data.model == 0">
                  <BaseSelect :options="screenFileSelect.options" :data="screenFileSelect.data" ref="screenFileSelect">
                  </BaseSelect>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="12" class="form-group" v-if="typeAreaSelect.data.model == 1">
                  <label>Chọn vùng <span class="required">*</span></label>
                  <CDataTable :items="dataMultipleArea.items" :fields="dataMultipleArea.fields">
                    <template #area="{ item }">
                      <td style="font-weight: bold">
                        {{ item.area }}
                      </td>
                    </template>
                    <template #isMute="{ item, index }">
                      <td>
                        <span v-if="item.isMute != null">
                          <CInputRadio :custom="true" :checked="item.isMute" name="isMute"
                            @update:checked="changeIsMute(index)" addInputClasses="override-custom"></CInputRadio>
                        </span>
                      </td>
                    </template>
                    <template #type="{ item, index }">
                      <td>
                        <BaseSelect :options="item.type.options" :data="item.type.data"
                          @update-change="changeTypeArea(item, index)">
                        </BaseSelect>
                      </td>
                    </template>
                    <template #sourceType="{ item, index }">
                      <td>
                        <span v-if="item.type.data.model == 0">
                          <BaseSelect :options="item.sourceType.options" :data="item.sourceType.data"
                            @update-change="changeSourceType(item, index)">
                            >
                          </BaseSelect>
                        </span>
                      </td>
                    </template>
                    <template #file="{ item }">
                      <td>
                        <BaseSelect :options="item.file.options" :data="item.file.data">
                        </BaseSelect>
                      </td>
                    </template>
                  </CDataTable>
                </CCol>

                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model != 2">
                  <div class="form-group">
                    <label for="dateRanger">Ngày bắt đầu - Ngày kết thúc
                      <span class="required">*</span></label>
                    <DatePicker locale="vi" id="dateRanger" v-model="dateRange" is-range class="datepicker"
                      :input-props="{ readonly: true }" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                      :min-date="new Date()">
                      <template v-slot="{ inputValue, inputEvents }">
                        <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                          class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300 " readonly />
                      </template>
                    </DatePicker>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1">
                  <BaseSelect :options="modeScheduleSelect.options" :data="modeScheduleSelect.data"
                    ref="modeScheduleSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1 || modeSelect.data.model == 0">
                  <div class="form-group mb-0"
                    :class="!(validatorRangeTimes ? validatorRangeTimes.isValid : true) ? 'input-error' : ''">
                    <label>Thời điểm phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <CRow>
                          <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange" :key="index">
                            <DatePicker locale="vi" mode="time" :masks="{ input: 'HH:MM', data: 'HH:MM' }" :value="each"
                              is-range is24hr @input="changeTimeRange($event, index)" ref="timeRange">
                              <template v-slot="{ inputValue, inputEvents, togglePopover, hidePopover }">
                                <!--                                <CInput class="btn-time-ranger"-->
                                <!--                                        :value="inputValue.start + ' - ' + inputValue.end"-->
                                <!--                                        v-on="inputEvents.start"-->
                                <!--                                        readonly-->
                                <!--                                />-->
                                <div class="form-group">
                                  <input type="text" :style="each.isValid ? 'border-color:red!important;' : ''"
                                    class="btn-time-ranger form-control"
                                    :value="inputValue.start + ' - ' + inputValue.end" readonly v-on="inputEvents.start">
                                </div>
                                <svg v-c-tooltip.hover="'Xóa'" class="w-1 h-1 btn-remove-time" viewBox="0 0 24 24"
                                  stroke="currentColor" stroke-width="2" @click="removeTimeRange(index)">
                                  <path d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                              </template>
                            </DatePicker>
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol>
                            <CButton color="primary" class="mt-3" @click="addTimeRange()">
                              <i class="fa fa-plus"></i> Thêm
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="sortRangeTime(true)">
                              <i class="fa fa-sort"></i> Sắp xếp
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="timeRange = []">
                              <i class="fa fa-eraser"></i> Xóa tất cả
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorRangeTimes ? validatorRangeTimes.isValid : true)">
                      {{ validatorRangeTimes ? validatorRangeTimes.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 2">
                  <div class="form-group"
                    :class="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker">Thời gian kết thúc phát
                      <span class="required">*</span></label>
                    <br />
                    <DatePicker locale="vi" id="endTimeUrgencyPicker" mode="time" v-model="endTimeUrgency"
                      :masks="{ input: 'HH:MM', data: 'HH:MM' }" is24hr>
                    </DatePicker>
                  </div>
                  <div class="form-row">
                    <div class="valid-error" style="padding: unset!important;"
                      v-show="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true)">
                      {{ validatorEndTimeUrgency ? validatorEndTimeUrgency.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6"
                  v-if="modeScheduleSelect.data.model == 0 && modeSelect.data.model == 1">
                  <div class="form-group">
                    <label for="selectedDateWeek">Ngày phát <span class="required">*</span></label>
                    <multiselect id="selectedDateWeek" v-model="selectedDateWeek.data.model" placeholder="Ngày phát"
                      label="value" track-by="key" :options="selectedDateWeek.data.items" selectLabel="Chọn"
                      deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false" :multiple="true"
                      :class="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true) ? 'input-error' : ''">
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>
                    <div class="valid-error"
                      v-show="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true)">
                      {{ selectedDateWeek.data.validator ? selectedDateWeek.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6"
                  v-if="modeSelect.data.model == 1 && modeScheduleSelect.data.model == 1">
                  <div class="form-group" :class="!(validatorDates ? validatorDates.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker">Ngày phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <DatePicker locale="vi" id="datepicker" mode="date" v-model="selectedDate.date"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" :min-date="minDate" :max-date="maxDate"
                          :is-required="true">
                          <template #default="{
                            inputValue,
                            togglePopover,
                            hidePopover,
                          }">
                            <div class="flex flex-wrap">
                              <CButton v-for="(each, i) in dates"
                                :key="each.date != null ? each.date.getTime() : new Date().getTime()" color="light"
                                class="mr-3 mt-3 btn-date" style="position: relative"
                                @click.stop="dateSelected($event, each, togglePopover)" ref="btnDate">
                                {{ $helper.formatDateDDMMYYYY(each.date) }}
                                <div class="btn-remove">
                                  <svg class="w-1 h-1" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                                    @click.stop="removeDate(each, hidePopover)">
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </div>
                              </CButton>
                            </div>
                          </template>
                        </DatePicker>
                        <CButton color="primary" class="mt-3" :disabled="checkDisableAddDate" @click="addDate">
                          <i class="fa fa-plus"></i> Thêm ngày
                        </CButton>
                        <CButton color="secondary" class="mt-3 ml-2" @click="dates = []">
                          <i class="fa fa-eraser"></i> Xóa tất cả
                        </CButton>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorDates ? validatorDates.isValid : true)">
                      {{ validatorDates ? validatorDates.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <br />
              <CRow>
                <CCol xs="12" md="12" lg="12" xl="12">
                  <CButton color="primary" @click="submitData()"><i class="fa fa-send"></i> Gửi tệp tin
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="resetData()"><i class="fa fa-eraser"></i> Làm mới
                  </CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import { DatePicker } from "v-calendar";
import { LOCATION_CODE_NAME } from "@/constant";
import Multiselect from "vue-multiselect";
import BaseLoading from "../../base/BaseFormLoading";
import { TypeArea } from '../../../constant';

export default {
  name: "ScreenSendFileToStation",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect,
    BaseLoading,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    return {
      loading: { value: false },
      isSelectedAllStation: false,
      allFileScreen: {
        editors: {
          all: [],
          text: []
        },
        center: {
          all: [],
          text: []
        },
        all: [],
        allByText: []
      },
      allPlayList: {
        texts: [],
        all: []
      },

      minDate: today,
      maxDate: today,
      dates: [],
      selectedDate: {},
      endTimeUrgency: this.$helper.plusDate(10, 'm')._d,
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
      timeRange: [],

      typeAreaSelect: {
        options: {
          label: "Loại phân vùng <span class='required'>*</span>",
          filter: false,
        },
        data: {
          name: "typeArea",
          items: [
            { key: "0", value: "Toàn màn hình" },
            { key: "1", value: "Phân 3 vùng" },
          ],
          model: this.$route.query['fileId'] ? "0" : "1",
        },
      },
      typeFileSelect: {
        options: {
          filter: false,
          label: "Loại tệp tin <span class='required'>*</span>",
        },
        data: {
          name: "typeFile",
          items: [
            { key: "0", value: "Theo kho tệp tin biên tập" },
            { key: "1", value: "Theo danh sách phát" },
          ],
          model: "0",
        },
      },
      sourceTypeSelect: {
        options: {
          filter: false,
          label: "Nguồn tệp tin <span class='required'>*</span>",
        },
        data: {
          name: "sourceType",
          items: [
            { key: "-1", value: "Tất cả nguồn tệp tin" },
            { key: "0", value: "Tệp tin TW" },
            { key: "1", value: "Tệp tin biên tập" },
          ],
          model: this.$route.params && (this.$route.query.sourceType || this.$route.query.sourceType == 0) ? this.$route.query.sourceType : "-1",
        },
      },
      screenFileSelect: {
        options: {
          filter: true,
          label: "Tệp tin <span class='required'>*</span>",
          keyField: "value",
          valueField: "text",
          selectAllText: "Chọn tệp tin",
        },
        data: {
          name: "fileId",
          model: this.$route.params && this.$route.query.fileId ? this.$route.query.fileId : "",
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.screenFileSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tệp tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      screenStationSelect: {
        options: [],
        data: {
          name: "lstStation",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.screenStationSelect.data.model;
              if (value === "" || that.screenStationSelect.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Nhóm màn hình không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      screenDeviceSelect: {
        options: [],
        data: {
          name: "devices",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.screenDeviceSelect.data.model;
              if (value === "" || that.screenDeviceSelect.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Thiết bị không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      modeSelect: {
        options: {
          label: "Chế độ phát <span class='required'>*</span>",
          filter: false,
        },
        data: {
          name: "mode",
          items: [
            { key: "0", value: "Khung giờ cố định" },
            { key: "1", value: "Theo lịch phát đã thiết lập" },
            { key: "2", value: "Khẩn cấp phát ngay" },
          ],
          model: "0",
        },
      },
      modeScheduleSelect: {
        options: {
          label: "Kiểu lịch",
          filter: false,
        },
        data: {
          name: "modeSchedule",
          items: [
            { key: "0", value: "Theo ngày trong tuần" },
            { key: "1", value: "Theo ngày trong tháng" },
          ],
          model: "0",
        },
      },
      selectedDateWeek: {
        options: {
          label: "Ngày phát",
        },
        data: {
          name: "selectedDateWeek",
          model: "",
          items: [
            { key: "2", value: "Thứ 2" },
            { key: "3", value: "Thứ 3" },
            { key: "4", value: "Thứ 4" },
            { key: "5", value: "Thứ 5" },
            { key: "6", value: "Thứ 6" },
            { key: "7", value: "Thứ 7" },
            { key: "1", value: "Chủ nhật" },
          ],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedDateWeek.data.model;
              if (
                (value === "" || value.length == 0) &&
                that.modeSelect.data.model == 1 &&
                that.modeScheduleSelect.data.model == 0
              ) {
                this.isValid = false;
                this.errorMessage = "Ngày phát phát không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },

      dataMultipleArea: {
        items: [
          {
            area: 'Vùng thông báo',
            typeArea: TypeArea.VUNG_THONG_BAO,
            isMute: null,
            type: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "0", value: "Theo kho tệp tin biên tập" },
                  { key: "1", value: "Theo danh sách phát" },
                ],
                model: "0",
              },
            },
            sourceType: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "-1", value: "Tất cả nguồn tệp tin" },
                  { key: "0", value: "Tệp tin TW" },
                  { key: "1", value: "Tệp tin biên tập" },
                ],
                model: "-1",
              },
            },
            file: {
              options: {
                selectAllText: "Chọn tệp tin",
                keyField: "value",
                valueField: "text",
              },
              data: {
                items: [],
                model: "",
                validator: {
                  isValid: true,
                  errorMessage: "",
                  valid: function () {
                    let value = that.dataMultipleArea.items[0].file.data.model;
                    if (value === "") {
                      this.isValid = false;
                      this.errorMessage = "Tệp tin không được để trống";
                    } else {
                      this.isValid = true;
                    }
                    return this.isValid;
                  },
                },
              },
            }
          },
          {
            area: 'Vùng bên trái',
            typeArea: TypeArea.VUNG_TRAI,
            isMute: true,
            type: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "0", value: "Theo kho tệp tin biên tập" },
                  { key: "1", value: "Theo danh sách phát" },
                ],
                model: "0",
              },
            },
            sourceType: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "-1", value: "Tất cả nguồn tệp tin" },
                  { key: "0", value: "Tệp tin TW" },
                  { key: "1", value: "Tệp tin biên tập" },
                ],
                model: "-1",
              },
            },
            file: {
              options: {
                selectAllText: "Chọn tệp tin",
                keyField: "value",
                valueField: "text",
              },
              data: {
                items: [],
                model: "",
                validator: {
                  isValid: true,
                  errorMessage: "",
                  valid: function () {
                    let value = that.dataMultipleArea.items[1].file.data.model;
                    if (value === "") {
                      this.isValid = false;
                      this.errorMessage = "Tệp tin không được để trống";
                    } else {
                      this.isValid = true;
                    }
                    return this.isValid;
                  },
                },
              },
            }
          },
          {
            area: 'Vùng bên phải',
            typeArea: TypeArea.VUNG_PHAI,
            isMute: false,
            type: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "0", value: "Theo kho tệp tin biên tập" },
                  { key: "1", value: "Theo danh sách phát" },
                ],
                model: "0",
              },
            },
            sourceType: {
              options: {
                filter: false
              },
              data: {
                items: [
                  { key: "-1", value: "Tất cả nguồn tệp tin" },
                  { key: "0", value: "Tệp tin TW" },
                  { key: "1", value: "Tệp tin biên tập" },
                ],
                model: "-1",
              },
            },
            file: {
              options: {
                selectAllText: "Chọn tệp tin",
                keyField: "value",
                valueField: "text",
              },
              data: {
                items: [],
                model: "",
                validator: {
                  isValid: true,
                  errorMessage: "",
                  valid: function () {
                    let value = that.dataMultipleArea.items[2].file.data.model;
                    if (value === "") {
                      this.isValid = false;
                      this.errorMessage = "Tệp tin không được để trống";
                    } else {
                      this.isValid = true;
                    }
                    return this.isValid;
                  },
                },
              },
            }
          },
        ],
        fields: [
          { key: 'area', label: 'Vùng phát', _style: "width:15%;" },
          { key: 'isMute', label: 'Tắt âm', _style: "width:10%;" },
          { key: 'type', label: 'Loại tệp tin', _style: "width:25%" },
          { key: 'sourceType', label: 'Nguồn tệp tin', _style: "width:25%" },
          { key: 'file', label: 'Tệp tin' },
        ]
      },

      validatorRangeTimes: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.timeRange;
          if ((value === "" || value.length == 0) && that.modeSelect.data.model != 2) {
            this.isValid = false;
            this.errorMessage = "Thời điểm phát không được để trống";
          } else {
            // this.isValid = true;
            var validRes = that.validateRangeTimeSorted();
            this.isValid = validRes.isValid;
            if (this.isValid) {
              this.errorMessage = "";
            } else {
              if (validRes.type == 0) {
                this.errorMessage = "Thời gian bắt đầu phải lớn hơn hoặc bằng thời gian hiện tại";
              } else {
                this.errorMessage = "Khoảng thời gian phát bị trùng nhau";
              }
            }
          }
          return this.isValid;
        },
      },
      validatorDates: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.dates;
          if (
            (value === "" || value.length == 0) &&
            that.modeSelect.data.model == 1 &&
            that.modeScheduleSelect.data.model == 1
          ) {
            this.isValid = false;
            this.errorMessage = "Ngày phát phát không được để trống";
          } else {
            this.isValid = true;
          }
          return this.isValid;
        },
      },
      validatorEndTimeUrgency: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.endTimeUrgency.getTime();
            if (value !== "" && that.modeSelect.data.model == 2) {
              if (value <= new Date()) {
                this.isValid = false;
                this.errorMessage = "Thời gian kết thúc phát phải lớn hơn thời gian hiện tại";
              } else {
                this.isValid = true;
              }
            }
            return this.isValid;
          },
      },

    };
  },
  computed: {
    checkDisableAddDate() {
      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (this.dates.length <= daysDiff) {
        return false;
      }
      return true;
    }
  },
  methods: {
    changeSelectedAllStation(value) {
      if (value) {
        this.screenStationSelect.data.model = this.screenStationSelect.options;
      } else {
        this.screenStationSelect.data.model = '';
      }
    },
    changeTimeRange(event, index) {
      this.timeRange.splice(index, 1, event);
    },
    addTimeRange() {
      // this.timeRange.push({start: new Date(), end: this.$helper.plusDate(10, 'm')._d})
      if (this.timeRange.length == 0) {
        this.timeRange.push(
          {
            start: this.$helper.plusDateTime(5, 'm').second(0).millisecond(0)._d,
            end: this.$helper.plusDateTime(13, 'm').second(0).millisecond(0)._d,
            isValid: false
          })
      } else {
        var rangeTimeSorted = this.sortRangeTime();
        var timeEnd = rangeTimeSorted[rangeTimeSorted.length - 1].end;
        this.timeRange.push({
          start: timeEnd,
          end: moment(timeEnd).add(10, 'm').second(0).millisecond(0).toDate(),
          isValid: false
        })
      }
    },
    sortRangeTime(isClick) {
      var timeArr = this.timeRange;
      var sortedTime = [];
      var tempTimesArr = [];
      timeArr.forEach(function (each, index) {
        tempTimesArr.push({ time: moment(each.start, "hh:mm").unix(), index: index });
      });
      tempTimesArr.sort(function (a, b) {
        return a.time - b.time;
      });

      tempTimesArr.forEach(function (t) {
        sortedTime.push(timeArr[t.index])
      });
      if (isClick) {
        this.timeRange = sortedTime;
      } else {
        return sortedTime;
      }
    },
    validateRangeTimeSorted() {
      var rangeTimeSorted = this.sortRangeTime();
      var response = {
        isValid: true,
      }
      var isValid = true;
      var now = moment().second(0).millisecond(0)._d.getTime();
      for (let i = 0; i < rangeTimeSorted.length; i++) {
        var _from = new Date(this.dateRange.start.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
        if (_from < now) {
          response.isValid = false;
          response.type = 0;
          break;
        }
        if (i > 0) {
          if (rangeTimeSorted[i].start.getTime() < rangeTimeSorted[i - 1].end.getTime()) {
            response.isValid = false;
            response.type = 1;
            break;
          }
        }
      }
      return response;
    },
    removeTimeRange(index) {
      this.timeRange.splice(index, 1);
    },
    addDate() {
      // let that = this;
      // var date = new Date();
      // date.setDate(this.dateRange.start.getDate());
      // this.dates.push({date: date});
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
      //     btn.click();
      //   }, 50);
      // });
      let that = this;

      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (daysDiff < this.dates.length) {
        return;
      }

      var date = new Date();
      date.setDate(this.dateRange.start.getDate());
      this.dates.push({ date: date });
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
          btn.click();
        }, 50);
      });
    },
    removeDate(date, hide) {
      this.dates = this.dates.filter((d) => d !== date);
      hide();
    },
    dateSelected(e, date, toggle) {
      this.selectedDate = date;
      toggle({ ref: e.target });
    },
    resetData() {
      this.sourceTypeSelect.data.model = "-1";
      this.screenFileSelect.data.model = "";
      this.screenStationSelect.data.model = "";
      this.modeSelect.data.model = "0";
      this.modeScheduleSelect.data.model = "0";
      this.screenDeviceSelect.data.model = "";
      this.minDate = new Date();
      this.maxDate = new Date();
      this.endTimeUrgency = this.$helper.plusDate(10, 'm')._d
      this.timeRange = [];
      this.dateRange = {
        start: this.minDate,
        end: this.maxDate,
      };
      this.resetTime();
      this.dataMultipleArea.items.forEach(each => each.file.data.model = "");
    },
    resetTime() {
      this.startTimes = [];
      this.endTimes = [];
      this.selectedDateWeek.data.model = [];
      this.dates = [];
    },

    changeIsMute(index) {
      for (let i = 1; i < this.dataMultipleArea.items.length; i++) {
        if (i === index) {
          this.dataMultipleArea.items[i].isMute = true;
        } else {
          this.dataMultipleArea.items[i].isMute = false;
        }
      }
    },
    changeTypeArea(item, index) {
      if (item.type.data.model == 0) {
        if (index == 0) {
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.allByText;
        } else {
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.all;
        }
      } else if (item.type.data.model == 1) {
        if (item.typeArea == 1) {
          this.dataMultipleArea.items[index].file.data.items = this.allPlayList.texts;
        } else {
          this.dataMultipleArea.items[index].file.data.items = this.allPlayList.all;
        }
      }
      this.dataMultipleArea.items[index].sourceType.data.model = "-1";
    },
    changeSourceType(item, index) {
      if (index == 0) {
        if (item.sourceType.data.model == 0) {  // Trung ương
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.center.text;
        } else if (item.sourceType.data.model == 1) {   // Biên tập
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.editors.text;
        } else if (item.sourceType.data.model == -1) {   // Tất cả
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.allByText;
        }
      } else {
        if (item.sourceType.data.model == 0) {  // Trung ương
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.center.all;
        } else if (item.sourceType.data.model == 1) {   // Biên tập
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.editors.all;
        } else if (item.sourceType.data.model == -1) {    // Tất cả
          this.dataMultipleArea.items[index].file.data.items = this.allFileScreen.all;
        }
      }
    },

    loadAllFileScreen() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/screen-file/listAllScreenFileBySourceType",
        dataSubmit() {
          return {
            sourceType: -1
          };
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let data = response.data.data;
            that.allFileScreen.all = response.data.data;
            that.screenFileSelect.data.items = data;

            setTimeout(() => {
              that.screenFileSelect.data.model = (that.$route.params && that.$route.query.fileId) ? that.$route.query.fileId : '';
            }, 100);

            // Loại tệp tin (type): 0 - Văn bản, 1 - Hình ảnh, 2 - Video
            // Nguồn tệp tin (sourceType) : 0 - Trung Ương, 1 - Biên tập
            data.map(each => {
              if (each.sourceType == 0) { // Trung ương
                if (each.type == 0) {
                  that.allFileScreen.center.text.push(each);
                }
                that.allFileScreen.center.all.push(each);
              } else if (each.sourceType == 1) {  // Biên tập
                if (each.type == 0) {
                  that.allFileScreen.editors.text.push(each);
                }
                that.allFileScreen.editors.all.push(each);
              }

              if (each.type == 0) {
                that.allFileScreen.allByText.push(each);
              }
            })

            for (let i = 0; i < that.dataMultipleArea.items.length; i++) {
              if (i == 0) {
                that.dataMultipleArea.items[i].file.data.items = that.allFileScreen.allByText;
              } else {
                that.dataMultipleArea.items[i].file.data.items = that.allFileScreen.all;
              }
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadAllPlayList() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/play-list/listPlayListByLocationCode",
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let dataResponse = response.data.data;
            that.allPlayList.all = dataResponse;
            dataResponse.map(each => {
              if (each.type == 0) {     // Dạng văn bản
                that.allPlayList.texts.push(each);
              }
            })
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },

    loadDataScreenStation() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/screen-station/list-screen-station-code-name",
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.screenStationSelect.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadDataScreenDevice() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/screen-device/listDevice",
        dataSubmit() {
          let dataReq = [];
          if (that.screenStationSelect.data.model && that.screenStationSelect.data.model.length > 0) {
            that.screenStationSelect.data.model.forEach(each => dataReq.push(each.value));
          }
          return {
            locationCode: dataReq,
          };
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.screenDeviceSelect.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },

    submitData: function () {
      let that = this;
      let isValid = true;
      if (this.typeAreaSelect.data.model == 0) {
        isValid &= that.screenFileSelect.data.validator.valid();
      } else {
        that.dataMultipleArea.items.forEach(each => isValid &= each.file.data.validator.valid());
      }
      isValid &= that.screenStationSelect.data.validator.valid();
      isValid &= that.validatorRangeTimes.valid();
      isValid &= that.selectedDateWeek.data.validator.valid();
      isValid &= that.validatorDates.valid();
      isValid &= that.validatorEndTimeUrgency.valid();

      if (!isValid) {
        return;
      } else {
        let dataReq = {};
        let dates = [];
        for (let i = 0; i < that.dates.length; i++) {
          dates.push(that.$helper.formatDateDDMMYYYY(that.dates[i].date.getTime()));
        }
        let startTimes = [];
        let endTimes = [];
        for (let i = 0; i < that.timeRange.length; i++) {
          startTimes.push(that.$helper.formatHHMMSS(that.timeRange[i].start.getTime()));
          endTimes.push(that.$helper.formatHHMMSS(that.timeRange[i].end.getTime()));
        }

        if (that.modeSelect.data.model == 2) {
          endTimes.push(that.$helper.formatHHMMSS(that.endTimeUrgency.getTime()));
        }

        dataReq.dates = dates;
        dataReq.startTimes = startTimes;
        dataReq.endTimes = endTimes;
        dataReq.fromDate = that.$helper.formatDateDDMMYYYY(that.minDate.getTime());
        dataReq.toDate = that.$helper.formatDateDDMMYYYY(that.maxDate.getTime());
        dataReq.sourceType = that.sourceTypeSelect.data.model;
        dataReq.fileId = that.screenFileSelect.data.model;
        dataReq.lstStation = [];
        for (let i = 0; i < that.screenStationSelect.data.model.length; i++) {
          dataReq.lstStation.push({
            locationCode: that.screenStationSelect.data.model[i].value,
            contractorInformationId: that.screenStationSelect.data.model[i].type
          });
        }
        dataReq.mode = that.modeSelect.data.model;
        dataReq.modeSchedule = that.modeScheduleSelect.data.model;
        if (that.selectedDateWeek.data.model.length > 0) {
          dataReq.selectedDateWeek = [];
          for (let i = 0; i < that.selectedDateWeek.data.model.length; i++) {
            dataReq.selectedDateWeek.push(that.selectedDateWeek.data.model[i].key);
          }
        }
        let lsDevice = [];
        if (that.screenDeviceSelect.data.model && that.screenDeviceSelect.data.model.length > 0) {
          that.screenDeviceSelect.data.model.forEach(each => lsDevice.push({
            code: each.value,
            locationCode: each.type
          }));
        }
        dataReq.lstDeviceCode = lsDevice;
        dataReq.typeArea = that.typeAreaSelect.data.model;
        dataReq.typeFile = that.typeFileSelect.data.model;
        dataReq.lstArea = [];
        for (let i = 0; i < that.dataMultipleArea.items.length; i++) {
          var item = {
            'typeArea': that.dataMultipleArea.items[i].typeArea,
            'isMute': that.dataMultipleArea.items[i].isMute,
            'type': that.dataMultipleArea.items[i].type.data.model,
            'sourceType': that.dataMultipleArea.items[i].sourceType.data.model,
            'file': that.dataMultipleArea.items[i].file.data.model
          }
          dataReq.lstArea.push(item);
        }
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/send-to-station/send-screen-file",
          dataSubmit: function () {
            return dataReq;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data), });
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({ message: "Hệ thống đã gửi tệp tin. Vui lòng đợi thông báo. Xin cảm ơn!" });
              that.resetData();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
  },
  created: function () {
  },
  mounted() {
    this.loadAllFileScreen();
    this.loadAllPlayList();

    this.loadDataScreenStation();
    this.loadDataScreenDevice();
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.minDate = newValue.start;
        this.maxDate = newValue.end;
      }
    },
    "sourceTypeSelect.data.model": function (value) {
      if (value == 0) {  // Trung ương
        this.screenFileSelect.data.items = this.allFileScreen.center.all;
      } else if (value == 1) {  // Biên tập
        this.screenFileSelect.data.items = this.allFileScreen.editors.all;
      } else if (value == -1) {
        this.screenFileSelect.data.items = this.allFileScreen.all;
      }
    },
    "modeSelect.data.model": function (newValue) {
      if (newValue) {
        if(newValue == 2) {
          this.minDate = new Date();
          this.maxDate = new Date();
        }
        this.resetTime();
        this.endTimeUrgency = this.$helper.plusDate(10, 'm')._d;
      }
    },
    "typeFileSelect.data.model": function (value) {
      if (value == 0) {
        let that = this;
        this.screenFileSelect.data.items = this.allFileScreen.all;
        if (this.$route.params && this.$route.query.fileId) {
          setTimeout(() => {
            that.screenFileSelect.data.model = that.$route.query.fileId;
          }, 100)
        }
      } else {
        this.screenFileSelect.data.items = this.allPlayList.all;
      }
    },
    "modeScheduleSelect.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
    },
    "screenStationSelect.data.model": function (data) {
      if (data.length == this.screenStationSelect.options.length) {
        this.isSelectedAllStation = true;
      } else {
        this.isSelectedAllStation = false;
      }
      this.loadDataScreenDevice();
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-date:hover .btn-remove {
  display: inline-flex !important;
}

.btn-remove {
  display: none !important;
  position: absolute;
  width: 15px;
  height: 15px;
  background: red;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  right: -5px;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
  border-color: unset;
  background-color: unset;
}

.form-group.input-error .card {
  border-color: #ff7070 !important;
}

.btn-time-ranger:hover~.btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
<style>
.input-error #endTimeUrgencyPicker {
  border-color: #ff7070;
}

.override-custom {
  opacity: 1 !important;
  z-index: 10 !important;
}

.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}

.vc-date {
  display: none !important;
}

.multiselect,
.multiselect .multiselect__tags {
  /*height: 36px !important;*/
  min-height: 36px !important;
}

.multiselect__input {
  line-height: unset !important;
  /*padding-left: 1px !important;*/
  font-size: 14px !important;
  padding-top: 5px !important;
}

.multiselect .multiselect__tags {
  padding-top: 0px !important;
}

.multiselect__placeholder {
  padding-top: 7px !important;
  margin: 0 !important;
}

.multiselect .multiselect__tag {
  margin-top: 5px !important;
  margin-bottom: 0 !important;
}
</style>
